module.exports = __webpack_public_path__ + "static/media/icon-location-on.41ea9493.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-location-on.svg
// module id = 663
// module chunks = 0